import React, { useEffect, useState } from 'react'
import { RouteImage } from '../../assets/routeImage'
import { Badge, Box, Typography } from '@mui/material';
import { colors } from '../../constants/colors';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { toggle } from '../../store/slice/navbarActive/navbarSlice';
import { NavigateFunction, useNavigate, useLocation } from 'react-router-dom'
import { logout, setToken } from '../../utils/app.utils'
import { Authentication } from '../../api/auth/Authentication.api';
import moment from 'moment';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';

// COMPONENT
import Loading from '../../component/loading/Loading';

// STORE
import { handleAddProfile } from '../../store/slice/profileSlice/profile.slice';
import { setPermission } from '../../store/slice/permission/permission.slice';
import { changeIdFiscalYear } from '../../store/slice/fiscal-year/fiscalYear.slice';
import { NotificationApi } from '../../api/notification/notification.api';

type Props = {}

const Header: React.FC = (props: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();
    const refreshToken = localStorage.getItem('REFRESH_TOKEN');
    const profileStore: any = useSelector((state: any) => state?.profile?.profile);

    const location = useLocation();
    const tokenTime: any | null = moment(localStorage.getItem('DATE_TOKEN_EXPIRED'));
    const permission = useSelector((state: any) => state?.permission?.permission);

    const [countNotification, setCountNotification] = useState<number>(Number);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [anchorManual, setAnchorManual] = useState<null | HTMLElement>(null);
    const [profile, setProfile] = useState<any>(profileStore || null)
    const [pathUrl, setPathUrl] = useState<any>(null);

    const [manual, setManual] = useState<{ manualName: string, manualPath: string }[]>([
        {
            manualName: "คู่มือการใช้งานระบบ e-Monitoring",
            manualPath: `user-manual`
        },
        {
            manualName: "ยุทธศาสตร์ชาติ",
            manualPath: `national-strategy`
        },
        {
            manualName: "แผนแม่บทและแผนย่อยภายใต้ยุทธศาสตร์ชาติ",
            manualPath: `master-plan`
        },
        {
            manualName: "แผนพัฒนาจังหวัดลำปาง",
            manualPath: `province-plan`
        },
        {
            manualName: "แผนพัฒนาท้องถิ่นเทศบาลนครลำปาง",
            manualPath: `local-plan`
        },
    ])

    const open = Boolean(anchorEl);
    const openManual = Boolean(anchorManual);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget)
    const handleClose = () => setAnchorEl(null)
    const handleToggle = () => dispatch(toggle())

    const handleClickManual = (event: React.MouseEvent<HTMLElement>) => setAnchorManual(event.currentTarget)
    const handleCloseManual = () => setAnchorManual(null)

    const handleLogout = async () => {
        setIsLoading(true)
        await Authentication.logout()
            .then(res => {
                if (res.status === 200) {
                    setIsLoading(false)
                    logout();
                    window.location.href = '/login'
                }
            })
            .catch(error => {
                setIsLoading(false)
                console.log(error)
            })
    }
    const handleRefreshToken = async () => {
        if (refreshToken) {
            try {
                await Authentication.refresh({ refreshToken })
                    .then(res => {
                        if (res.status === 200) {
                            // localStorage.removeItem("TOKEN")
                            // localStorage.removeItem("REFRESH_TOKEN")
                            const accessToken: string = res.data?.result?.accessToken
                            const refreshToken: string = res.data?.result?.refreshToken
                            if (accessToken && refreshToken) {
                                setToken(accessToken);
                                localStorage.setItem('REFRESH_TOKEN', refreshToken);
                                localStorage.setItem('DATE_TOKEN_EXPIRED', res.data?.result?.expireDate)
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
                    .finally(() => {
                        window.location.href = location.pathname
                    })
            } catch (error) {
                logout()
                console.error(error);
            }
        }
    }
    const handleGetProfile = async () => {
        setIsLoading(true);
        try {
            await Authentication.getProfile()
                .then(res => {
                    if (res.status === 200) {
                        setIsLoading(false);
                        dispatch(handleAddProfile(res.data?.result));
                        const currentDate: Date = new Date();
                        const currentidFiscalYear = moment(currentDate).year();
                        dispatch(changeIdFiscalYear(currentidFiscalYear + 543))
                        if (JSON.stringify(profileStore) === JSON.stringify(res.data?.result)) {
                            setProfile(profileStore)
                        } else {
                            setProfile(res.data?.result)
                        }
                        if (permission.length < 0 || res.data?.result?.permission !== permission) {
                            dispatch(setPermission(res.data?.result?.permission))
                        }

                    } else if (res.status === 401) {
                        handleRefreshToken();
                        handleGetProfile();
                        setIsLoading(false);
                    } else {
                        logout();
                        setIsLoading(false);
                    }
                })
                .catch(error => {
                    logout();
                    console.log(error.response)
                })
        } catch (error) {
            setIsLoading(false);
            console.error(error);
        }
    };
    const handleGetCountNotification = async () => {
        await NotificationApi.countNotification()
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result)
                    setCountNotification(res.data?.result)
                }
            })
            .catch(error => {
                throw new Error("Can't Fetch data from api", error);
            })
    }

    useEffect(() => {
        const init = async () => {
            const response = await fetch("/resources/config.json");
            const results = await response.json();
            setPathUrl(results)
        }
        init();
    }, [])
    useEffect(() => {
        handleGetCountNotification();
    }, [])

    useEffect(() => {
        const currentTime = moment();
        const refreshThreshold: number = 5 * 60 * 1000;
        if (tokenTime) {
            const timeUntilExpiry = tokenTime.diff(currentTime);

            if (timeUntilExpiry < refreshThreshold && timeUntilExpiry > 0) {
                handleRefreshToken();
            } else if (timeUntilExpiry <= 0) {
                logout();
            }
        }
    }, [tokenTime])

    useEffect(() => {
        if (!profileStore) handleGetProfile();
    }, [])


    const renderManual = (isHidden?: boolean) => (
        <>
            <Button
                sx={{ padding: "0", width: "auto", minWidth: "0", cursor: "pointer", color: "#000" }}
                id="drop-down-header-manual"
                aria-controls={anchorManual ? 'fade-menu-manual' : undefined}
                aria-haspopup="true"
                aria-expanded={anchorManual ? 'true' : undefined}
                onClick={handleClickManual}
            >
                <button
                    // onClick={() => pathUrl && window.open(`${pathUrl?.REACT_APP_BASE_API}/user-manual`)}
                    className='flex'>
                    {isHidden ? <></> : <span className={`${isHidden ? '' : 'hidden'} md:inline-block`}><img src={RouteImage.book} alt="" /></span>}
                    <span className={`pl-1 ${isHidden ? '' : 'hidden'} md:inline-block`}>
                        <Typography sx={{ color: "#525D6A" }}>
                            {t("คู่มือการใช้งาน")}
                        </Typography>
                    </span>
                </button>
            </Button>
            <Menu
                id="fade-menu-manual"
                MenuListProps={{
                    'aria-labelledby': 'drop-down-header-manual',
                }}
                anchorEl={anchorManual}
                open={openManual}
                onClose={handleCloseManual}
                TransitionComponent={Fade}
            >
                {manual?.map((list) => {
                    return (
                        <MenuItem onClick={() => pathUrl && window.open(`${pathUrl?.REACT_APP_BASE_API}${list.manualPath}`)}>
                            <Typography>
                                {list.manualName}
                            </Typography>
                        </MenuItem>
                    )
                })}
            </Menu>
        </>
    )

    return (
        <>
            <main>
                {isLoading && <Loading />}

                <header
                    className={`w-full px-2 md:px-[44px] h-[80px] flex justify-between items-center border-b-[1px] border-primary`}>
                    <button className={`cursor-pointer z-[999]`} onClick={handleToggle}>
                        <img width={32} height={32} src={RouteImage.berger} alt="sidebar" />
                    </button>
                    <section className='flex w-auto max-w-none md:max-w-[600px] h-[42px]'>
                        <article className='flex md:flex flex-1 justify-start mr-3 items-center relative'>
                            {renderManual()}
                            <Badge

                                color='error'
                                max={999}
                                variant='standard'
                                badgeContent={countNotification || 0}
                                onClick={() => navigate('/auth/notification')}
                                className='hover:rotate-12 duration-15 cursor-pointer pl-3 md:mt-0 duration-150'
                            // className='pl-3 cursor-pointer flex justify-center gap-2 items-center hover:rotate-12 duration-150 md:mt-0'
                            >
                                <NotificationsNoneOutlinedIcon sx={{ color: colors.secondary }} />
                            </Badge>
                        </article>
                        <article className='h-full w-auto'>
                            <div className='h-full border-[1px] border-light hidden md:block'></div>
                        </article>
                        <article className='flex justify-between items-center gap-x-2 w-auto ml-3'>
                            <div className='w-[50px] h-[30px] md:h-full rounded-[50%] bg-[#E5E5E7] flex justify-center items-center'>
                                <img src={RouteImage.user} alt="user" />
                            </div>
                            <div className='w-full max-w-none md:max-w-[238px] flex justify-start items-center'>
                                <div className='relative'>
                                    <Button
                                        sx={{ padding: "0", width: "auto", minWidth: "0" }}
                                        id="drop-down-header"
                                        aria-controls={open ? 'fade-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={open ? 'true' : undefined}
                                        onClick={handleClick}
                                    >
                                        <div className='flex-col justify-start items-start hidden md:flex'>
                                            <span>
                                                <Typography className='text-primary' variant='body1'>
                                                    {profile &&
                                                        `${profile?.employeeFirstname} ${profile?.employeeLastname}`
                                                    }
                                                </Typography>
                                            </span>
                                            <span>
                                                <Typography sx={{ fontSize: "12px", fontWeight: 300, color: colors.lampang_text_secondary }}>
                                                    {profile && profile?.position?.positionName}
                                                </Typography>
                                            </span>
                                        </div>
                                        <div className='ml-4'>
                                            <img src={RouteImage.downArrow} alt="" />
                                        </div>
                                    </Button>
                                    <Menu
                                        sx={{ padding: "2em 1.5em" }}
                                        id="fade-menu"
                                        MenuListProps={{
                                            'aria-labelledby': 'drop-down-header',
                                        }}
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={handleClose}
                                        TransitionComponent={Fade}
                                    >
                                        {/* {permission?.find((list: any) => list?.code === "SystemUsers.Open")?.permit === true && (
                                            <MenuItem onClick={() => navigate('/auth/setting/system-users')}>จัดการผู้ใช้</MenuItem>
                                        )} */}
                                        <MenuItem>
                                            <Box sx={{ display: { lg: "none" } }}>
                                                {renderManual(true)}
                                            </Box>
                                        </MenuItem>
                                        <MenuItem onClick={handleLogout}>ออกจากระบบ</MenuItem>
                                    </Menu>
                                </div>
                            </div>
                        </article>
                    </section>
                </header>
            </main>
        </>
    )
}

export default Header